function setupWebViewJavascriptBridge (callback: any) {
 
    if ((window as any).WebViewJavascriptBridge) {
      return callback((window as any).WebViewJavascriptBridge)
    }
    if ((window as any).CYPWebViewJavascriptBridge) {
      return callback((window as any).CYPWebViewJavascriptBridge)
    }
    if ((window as any).WVJBCallbacks) {
      return (window as any).WVJBCallbacks.push(callback)
    }
    (window as any).WVJBCallbacks = [callback]
    let WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'https://__bridge_loaded__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }
  
  export default {
    callhandler (name: any, data: any, callback?: any) {
      setupWebViewJavascriptBridge(function (bridge: any) {
        bridge.callHandler(name, data, callback)
      })
    },
    registerhandler (name: any, callback: any) {
      setupWebViewJavascriptBridge(function (bridge: any) {
        bridge.registerHandler(name, function (data: any, responseCallback: any) {
          callback(data, responseCallback)
        })
      })
    }
  }
 